import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "fill"];
import React from 'react';

var PercentIcon = function PercentIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#333' : _ref$fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: fill,
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.563 1.255l2.433 2.765 3.64-.555a.75.75 0 0 1 .863.724l.086 3.682 3.146 1.915a.75.75 0 0 1 .195 1.11l-2.3 2.875 1.178 3.489a.75.75 0 0 1-.563.975l-3.611.724-1.34 3.43a.75.75 0 0 1-1.059.386L12 21.008l-3.231 1.767a.75.75 0 0 1-1.059-.385l-1.34-3.43-3.61-.725a.75.75 0 0 1-.564-.975l1.179-3.49-2.301-2.875a.75.75 0 0 1 .195-1.109l3.146-1.915.086-3.682a.75.75 0 0 1 .863-.724l3.64.555 2.433-2.765a.75.75 0 0 1 1.126 0zM12 2.885L9.86 5.319a.75.75 0 0 1-.676.246L5.98 5.076l-.076 3.24a.75.75 0 0 1-.36.623l-2.767 1.685 2.024 2.53c.16.2.207.466.125.708l-1.037 3.07 3.177.637a.75.75 0 0 1 .551.463l1.18 3.018 2.842-1.554a.75.75 0 0 1 .72 0l2.843 1.554 1.179-3.018a.75.75 0 0 1 .55-.463l3.178-.637-1.037-3.07a.75.75 0 0 1 .125-.708l2.024-2.53-2.767-1.685a.75.75 0 0 1-.36-.623l-.076-3.24-3.203.488a.75.75 0 0 1-.676-.246L12 2.886zm2.279 3.669a.75.75 0 0 1 .417.975l-4 10a.75.75 0 1 1-1.392-.558l4-10a.75.75 0 0 1 .975-.417zM15.5 11.5a2.25 2.25 0 0 1 2.25 2.25v1a2.25 2.25 0 1 1-4.5 0v-1a2.25 2.25 0 0 1 2.25-2.25zm0 1.5a.75.75 0 0 0-.75.75v1a.75.75 0 1 0 1.5 0v-1a.75.75 0 0 0-.75-.75zm-7-5.5a2.25 2.25 0 0 1 2.25 2.25v1a2.25 2.25 0 1 1-4.5 0v-1A2.25 2.25 0 0 1 8.5 7.5zm0 1.5a.75.75 0 0 0-.75.75v1a.75.75 0 1 0 1.5 0v-1A.75.75 0 0 0 8.5 9z"
  }));
};

PercentIcon.displayName = 'PercentIcon';
export default PercentIcon;